import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CheckboxMarker from './CheckboxMarker';


const Checkbox = props => {
  const { field, form, placeholder, children, disabled } = props;

  const error = form.errors[field.name];
  const hasValue = field.value != null && field.value !== '';

  const handleChange = (event) => {
    const { field, form } = props;
    const value = event.target.checked ? true : false;
    form.setFieldValue(field.name, value);
  };

  return (
    <label className={classNames(`field field-checkbox`, {
      'field--disabled': disabled,
    })}>
      <input
        {...field}
        disabled={disabled}
        type='checkbox'
        value={field.value}
        onChange={handleChange}
      />
      <CheckboxMarker isChecked={field.value || field.value === 1} />
      <div className="checkbox__title">
        {placeholder || children}
      </div>
      {
        (form.submitCount > 0 || form.touched[field.name]) &&
        <span className='field-error'>{error}</span>
      }
    </label>
  );
}

Checkbox.propTypes = {
  containerClassName: PropTypes.string,
}

Checkbox.defaultProps = {
  containerClassName: '',
  inputClassName: '',
}

export default Checkbox;